import { HeartFilled, HeartOutlined, PushpinOutlined } from "@ant-design/icons";
import { Button, Card } from "antd";
import React from "react";
import { connect } from "react-redux";
import { addWishlistItem, removeWishlistItem } from "../../../../api/wishlist.api";
import actions from "../../../../redux/settings/actions";
import styles from "./Product.module.scss";

const Product = (props) => {
  const [wishlisted, setWishlisted] = React.useState(false);
  const { settings: { wishlist, project } } = props;

  React.useEffect(() => {
    if (!wishlist || !wishlist[project?.id]) return;
    console.log("i-log> store wishlist", wishlist);
    if (wishlist[project?.id]?.find((item) => item?.product_id === props?.product?.id)) {
      setWishlisted(true);
    } else {
      setWishlisted(false);
    }
  }, [project, props?.product?.id, wishlist]);

  const getContent = () => {
    if (props.loading) return null;

    return (
      <Card.Meta title={props?.product?.title} description={props?.product?.vendorName} />
    )
  };

  const toggleWishlist = () => {
    if (!wishlisted) {
      const payload = { project: project?.id, product_id: props?.product?.id, variant_id: props?.product?.variants[0]?._id };
      addWishlistItem(payload.project, payload.product_id, payload.variant_id).then((res) => {
        props.dispatch({
          type: actions.SET_WISHLIST_REQ,
          payload: {
            projectId: project?.id,
            items: [
              ...wishlist[project?.id]?.items,
              {
                ...payload,
                variantDetails: props?.product?.variants[0],
              },
            ],
          },
        });
      });
      setWishlisted(true);
      return;
    }

    removeWishlistItem(project?.id, props?.product?.variants[0]?._id).then((res) => {
      props.dispatch({
        type: actions.SET_WISHLIST_REQ,
        payload: {
          projectId: project?.id,
          items: wishlist[project?.id]?.items?.filter((item) => item?.variant_id !== props?.product?.variants[0]?._id),
        },
      });
      setWishlisted(false);
    });
  };

  return (
    <Card
      loading={props.loading}
      style={{ height: 350 }}
      cover={!props.loading && props.product && (
        <div className={styles.imageContainer}>
          <Button
            shape="circle"
            icon={wishlisted ? <HeartFilled style={{ color: "red" }} /> : <HeartOutlined />}
            className={`${styles.pin} ${wishlisted ? styles.wishlisted : ""}`}
            type="default"
            size="large"
            onClick={e => {
              e.stopPropagation();
              toggleWishlist();
            }}
          />
          <img
            alt={props.product.images[0]?.imageAltText}
            src={props.product.images[0]?.imageUrl}
            style={{ width: '100%', height: '100%' }}
          />
        </div>
      )}
      hoverable
      onClick={() => {
        props.setProduct(props.product);
      }}
    >
      {getContent()}
    </Card>
  );
};

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

export default connect(mapStateToProps)(Product);